(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('header-menu details').forEach(details => {

  // Remove existing click functionality by cloning
  const cleanDetails = details.cloneNode(true);
  details.replaceWith(cleanDetails);

  // Add hover functionality
  cleanDetails.addEventListener('mouseenter', () => {
    cleanDetails.setAttribute('open', '');
  });

  cleanDetails.addEventListener('mouseleave', () => {
    cleanDetails.removeAttribute('open');
  });
});

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ronda-featured-rotation"] && !Shopify.designMode) return;
  try {
    
  function rondaFeaturedSelect(ids, week, prior = []) {
    const pool = [...new Set(ids)];
    if (!pool.length) return [];
    const start = ((week * 4) % pool.length + pool.length) % pool.length;
    const ordered = pool.slice(start).concat(pool.slice(0, start));
    const chosen = [...new Set(prior)].filter(id => pool.includes(id)).slice(0, 4);
    for (const id of ordered) {
      if (chosen.length === 4) break;
      if (!chosen.includes(id)) chosen.push(id);
    }
    return chosen;
  }
  if (!customElements.get('ronda-featured-rotation')) {
    customElements.define('ronda-featured-rotation', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const list = this.querySelector('.ronda-featured__list');
        const cards = [...list.children];
        const now = Date.now();
        const week = Math.floor((now - Date.UTC(2026, 8, 14, 4)) / 604800000);
        const key = 'ronda-featured-v1-' + this.dataset.sectionId;
        let stored;
        try { stored = JSON.parse(sessionStorage.getItem(key)); } catch {}
        const prior = stored && now >= stored.seen && now - stored.seen < 1800000 && Array.isArray(stored.ids) ? stored.ids : [];
        const selected = rondaFeaturedSelect(cards.map(card => card.dataset.productId), week, prior);
        for (const card of cards) card.hidden = !selected.includes(card.dataset.productId);
        for (const id of selected) list.append(cards.find(card => card.dataset.productId === id));
        list.dataset.count = String(selected.length);
        try { sessionStorage.setItem(key, JSON.stringify({ids:selected, seen:now})); } catch {}
        const navigation = this.querySelector('.ronda-featured__navigation');
        const previous = navigation.querySelector('.ronda-featured__previous');
        const next = navigation.querySelector('.ronda-featured__next');
        navigation.hidden = selected.length <= 2;
        const update = () => {
          previous.disabled = list.scrollLeft <= 1;
          next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
        };
        previous.addEventListener('click', () => list.scrollBy({left:-list.clientWidth, behavior:'auto'}));
        next.addEventListener('click', () => list.scrollBy({left:list.clientWidth, behavior:'auto'}));
        list.addEventListener('scroll', update, {passive:true});
        this.observer = new ResizeObserver(update);
        this.observer.observe(list);
        update();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ronda-single-related"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ronda-single-related')) {
customElements.define('ronda-single-related', class extends HTMLElement {
connectedCallback() {
  if (this.loaded) return;
  this.loaded = true;
  this.observer = new IntersectionObserver(entries => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    this.observer.disconnect();
    this.loadCards();
  }, {rootMargin: '400px'});
  this.observer.observe(this);
}
name(title) {
  return title.split(' – ')[0].replace(/\s*\([^)]*\)/g, '').trim()
    .replace(/\s+(?:-\s*)?(?:\d+\s+)?(?:SVP\s+)?[A-Z]{0,6}\d+[a-z]?(?:\/(?:[A-Z]*\d+[a-z]?|[A-Z]+(?:-[A-Z]+)*))?$/i, '')
    .replace(/\s*-\s*$/, '').trim()
    .replace(/\s+(VMAX|VSTAR|V-UNION|V|ex|GX|BREAK|LV\.X|Prime)$/i, '')
    .replace(/[’‘]/g, "'").replace(/\s+/g, ' ').trim().toLowerCase();
}
set(title) { return title.split(' – ').slice(1).join(' – ').trim().toLowerCase(); }
setValue(data) { return (data.set || this.set(data.title)).trim().toLowerCase(); }
identity(data) { return data.title.split(' – ')[0].toLowerCase().replace(/[’‘]/g, "'").replace(/\s+-\s+/g, ' ').replace(/\s+/g, ' ').trim() + '|' + this.setValue(data); }
async candidates(query) {
  const url = new URL(this.dataset.searchUrl, location.origin);
  url.searchParams.set('section_id', 'ronda-single-related');
  url.searchParams.set('type', 'product');
  url.searchParams.set('options[unavailable_products]', 'hide');
  url.searchParams.set('options[prefix]', 'none');
  url.searchParams.set('q', query);
  const current = new URL(location.href);
  for (const key of ['preview_theme_id', 'oseid']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
  const cards = [];
  const visited = new Set();
  let next = url;
  while (next && !visited.has(next.href)) {
    visited.add(next.href);
    try {
      const response = await fetch(next, {signal: this.controller.signal});
      if (!response.ok) throw new Error('Related products unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const template = doc.querySelector('template[data-related-candidates]');
      if (!template) throw new Error('Related products response missing');
      cards.push(...template.content.querySelectorAll('.ronda-related-card'));
      const href = template.content.querySelector('[data-related-next]')?.getAttribute('data-related-next');
      next = href ? new URL(href, url) : null;
      if (next) {
        if (next.origin !== url.origin || next.pathname !== url.pathname) break;
        for (const [key, value] of url.searchParams) next.searchParams.set(key, value);
      }
    } catch (error) { if (!cards.length) throw error; break; }
  }
  return cards;
}
async loadCards() {
  this.controller = new AbortController();
  const timeout = setTimeout(() => this.controller.abort(), 12000);
  const sourceName = this.name(this.dataset.title);
  const sourceSet = this.setValue(this.dataset);
  const quote = value => '"' + value.replace(/[\\"]/g, '\\$&') + '"';
  const queries = [];
  if (sourceName) queries.push('tag:singles AND title:' + quote(sourceName));
  if (this.dataset.setTag && sourceSet) queries.push('tag:singles AND (tag:' + quote(this.dataset.setTag) + ' OR title:' + quote(sourceSet) + ')');
  else if (this.dataset.setTag) queries.push('tag:singles AND tag:' + quote(this.dataset.setTag));
  else if (sourceSet) queries.push('tag:singles AND title:' + quote(sourceSet));
  try {
    const responses = await Promise.allSettled(queries.map(query => this.candidates(query)));
    if (!this.isConnected) return;
    const pool = responses.flatMap(result => result.status === 'fulfilled' ? result.value : []);
    const seen = new Set([this.identity(this.dataset)]);
    const ranked = pool.map(card => ({card, rank: this.name(card.dataset.title) === sourceName ? 0 : sourceSet && sourceSet !== 'miscellaneous cards & products' && this.setValue(card.dataset) === sourceSet ? 1 : 2})).filter(item => item.rank < 2 && item.card.dataset.productId !== this.dataset.productId);
    ranked.sort((a,b) => a.rank-b.rank || Math.abs(Number(a.card.dataset.price)-Number(this.dataset.price))-Math.abs(Number(b.card.dataset.price)-Number(this.dataset.price)));
    const selected = [];
    for (const {card} of ranked) {
      const key = this.identity(card.dataset);
      if (seen.has(key)) continue;
      seen.add(key);
      if (this.dataset.preview === 'true') {
        const link = card.querySelector('a');
        const url = new URL(link.getAttribute('href'), location.origin);
        url.searchParams.set('view', 'single-modelo');
        link.setAttribute('href', url.pathname + url.search);
      }
      selected.push(card);
      if (selected.length === 4) break;
    }
    if (selected.length) {
      this.querySelector('ul').replaceChildren(...selected);
      this.querySelector('section').hidden = false;
    }
    this.dataset.state = responses.every(result => result.status === 'rejected') ? 'error' : selected.length ? 'loaded' : 'empty';
  } catch (error) { this.dataset.state = 'error'; }
  finally { clearTimeout(timeout); }
}
disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
});
}

  } catch(e) { console.error(e); }
})();
})();
